export default () => {

  // const $SPOT_RECORD_DETAILS = window.$App.globals.spot.spotRecordDetail;
  // const $ALLOWED_STATION_CAPABILITIES = window.$App.globals.spot.allowedStationCapabilities;

  // return {
  //   $SPOT_RECORD_DETAILS,
  //   $ALLOWED_STATION_CAPABILITIES
  // }

  const spotGlobals = {}

  const globals = Object.entries(window.$App.globals.spot)
  globals.forEach((global) => (spotGlobals[`$${global[0].toUpperCase()}`] = global[1]))

  return spotGlobals;  
}